import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { convertErrorToLoginError } from "@faire/retailer-visitor-shared/components/AppSignIn/components/convertErrorToLoginError";
import { ErrorMessage } from "@faire/retailer-visitor-shared/components/AppSignIn/components/ErrorMessage";
import { LoginError } from "@faire/retailer-visitor-shared/components/AppSignIn/components/LoginError";
import { LoginWrapper } from "@faire/retailer-visitor-shared/components/AppSignIn/components/styled";
import { MIN_PASSWORD_LENGTH } from "@faire/retailer-visitor-shared/lib/consts";
import { handleKeyDown } from "@faire/retailer-visitor-shared/lib/handleKeyDown";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Button } from "@faire/web--source/slate/Button";
import { Input } from "@faire/web--source/slate/Input";
import { LoadingSpinner } from "@faire/web--source/slate/LoadingSpinner";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import changePassword from "@faire/web-api--source/api/user/change-password/post";
import validateResetPasswordToken from "@faire/web-api--source/api/v2/users/validate-reset-password-token/token/post";
import React, { useState, useEffect } from "react";
import styled from "styled-components";
export var ResetPassword = function(param) {
    var onReset = param.onReset, resetToken = param.resetToken;
    var strictLocalize = useStrictLocalization().strictLocalize;
    var _useState = _sliced_to_array(useState(true), 2), isValidatingResetPasswordToken = _useState[0], setIsValidatingResetPasswordToken = _useState[1];
    var _useState1 = _sliced_to_array(useState(""), 2), password = _useState1[0], setPassword = _useState1[1];
    var _useState2 = _sliced_to_array(useState(), 2), error = _useState2[0], setError = _useState2[1];
    useEffect(function() {
        if (!resetToken) {
            setError(new LoginError(strictLocalize({
                id: "H8GU6z",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Invalid reset token"
                    }
                ]
            })));
            setIsValidatingResetPasswordToken(false);
            return;
        }
        validateResetPasswordToken(resetToken).catch(function(e) {
            return setError(convertErrorToLoginError(e, strictLocalize));
        }).finally(function() {
            return setIsValidatingResetPasswordToken(false);
        });
    }, [
        resetToken,
        strictLocalize
    ]);
    var onContinue = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function() {
            var e;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (password.length < MIN_PASSWORD_LENGTH) {
                            setError(new LoginError(strictLocalize({
                                id: "tmeEM6",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Password needs at least 8 characters"
                                    }
                                ]
                            })));
                            return [
                                2
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            changePassword({
                                new_password: password,
                                reset_password_token: resetToken
                            })
                        ];
                    case 2:
                        _state.sent();
                        onReset();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        setError(convertErrorToLoginError(e, strictLocalize));
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function onContinue() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ _jsx(LoginWrapper, {
        children: isValidatingResetPasswordToken ? /*#__PURE__*/ _jsx(StyledLoadingSpinner, {
            "data-test-id": "spinner"
        }) : /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(Typography, {
                    variant: "pageHeaderSerifRegular",
                    children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "XJAXz2",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Reset your password"
                            }
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx(Spacer, {
                    height: "1x"
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "p24Pru",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Type your new password to receive access to Faire"
                            }
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx(Spacer, {
                    height: "3x"
                }),
                /*#__PURE__*/ _jsx(Input, {
                    autoFocus: true,
                    name: "password",
                    placeholder: strictLocalize({
                        id: "xF+m2Z",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "New Password"
                            }
                        ]
                    }),
                    autoComplete: "new-password",
                    "data-test-id": "password",
                    type: "password",
                    role: "password",
                    value: password,
                    onChange: function(event) {
                        return setPassword(event.currentTarget.value);
                    },
                    onKeyDown: handleKeyDown(onContinue)
                }),
                /*#__PURE__*/ _jsx(Spacer, {
                    height: "4x"
                }),
                /*#__PURE__*/ _jsx(Button, {
                    onClick: onContinue,
                    "data-test-id": "continueButton",
                    children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "PZ5Dke",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Reset Password"
                            }
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx(ErrorMessage, {
                    error: error
                })
            ]
        })
    });
};
var StyledLoadingSpinner = styled(LoadingSpinner).withConfig({
    componentId: "sc-c825e966-0"
})([
    "align-self:center;"
]);
